import { t } from 'ember-intl';
import AppPageHeroSection from 'tio-employee/components/app/page/hero-section';
import NavTabs from 'tio-reimagined/components/nav-tabs';
import { array, hash } from '@ember/helper';
import type { TOC } from '@ember/component/template-only';
import { Section, VStack } from 'tio-ui/components/layout';

interface QuestionsLoanForgivenessSignature {
  Args: {
    incomeRoute: string;
    indexRoute: string;
    teacherRoute: string;
  };
  Blocks: {
    default: [];
  };
}

const QuestionsLoanForgivenessComponent: TOC<QuestionsLoanForgivenessSignature> = <template>
  <VStack>
    <Section>
      <:body>
        <AppPageHeroSection class="-mx-4 -mt-4">
          <:title>
            {{t "pslf.questions.what_is_loan_forgiveness_q"}}
          </:title>
          <:body>
            {{t "pslf.questions.what_is_loan_forgiveness_a"}}
          </:body>
        </AppPageHeroSection>
        <h1 class="sr-only">
          {{t "pslf.questions.what_is_loan_forgiveness_q"}}
        </h1>
        <h2 class="pt-6 text-lg font-semibold text-gray-600">
          {{t "pslf.questions.whats_the_catch.title"}}
        </h2>
        <div class="flex flex-col sm:grid sm:grid-cols-3 gap-4">
          <p>{{t "pslf.questions.whats_the_catch.catch_1"}}</p>
          <p>{{t "pslf.questions.whats_the_catch.catch_2"}}</p>
          <p>{{t "pslf.questions.whats_the_catch.catch_3"}}</p>
        </div>
        <NavTabs
          class="pt-5"
          @tabs={{array
            (hash label=(t "pslf.questions.public_service.tab_title") route=@indexRoute)
            (hash label=(t "pslf.questions.income_driven.tab_title") route=@incomeRoute)
            (hash label=(t "pslf.questions.teacher.tab_title") route=@teacherRoute)
          }}
        />
        {{yield}}
      </:body>
    </Section>
  </VStack>
</template>;

export default QuestionsLoanForgivenessComponent;
